import { Megaphone } from 'lucide-react'
import ToolPage from '../../components/shared/ToolPage'
import type { ToolField } from '../../components/shared/ToolPage'

const fields: ToolField[] = [
  { name: 'name', label: 'Campaign Name', type: 'text', required: true },
  { name: 'topic', label: 'Campaign Goal', type: 'text', required: true, placeholder: 'e.g. Drive sign-ups for new feature' },
  { name: 'audience', label: 'Target Audience', type: 'text', required: true, placeholder: 'e.g. Indian SMB owners' },
  {
    name: 'tone', label: 'Tone', type: 'select', defaultValue: 'professional',
    options: [
      { value: 'professional', label: 'Professional' },
      { value: 'casual', label: 'Casual' },
      { value: 'friendly', label: 'Friendly' },
      { value: 'expert', label: 'Expert' },
    ],
  },
  { name: 'keywords', label: 'Keywords', type: 'text', placeholder: 'Comma-separated' },
  { name: 'channels', label: 'Channels', type: 'text', defaultValue: 'blog,social,email' },
  { name: 'product', label: 'Product Description', type: 'textarea', placeholder: 'Describe your product or service' },
]

function renderResult(data: any) {
  const r = data?.result || data

  return (
    <div className="space-y-6">
      {r?.campaign_name && <h2 className="text-lg font-bold">{r.campaign_name}</h2>}
      {r?.summary && <p className="text-sm text-gray-600">{r.summary}</p>}

      {r?.blog_posts?.length > 0 && (
        <div>
          <h3 className="text-sm font-semibold text-gray-900 mb-2">
            Blog Posts ({r.blog_posts.length})
          </h3>
          {r.blog_posts.map((p: any, i: number) => (
            <div key={i} className="p-3 bg-gray-50 rounded-lg mb-2">
              <p className="text-sm font-medium">
                {p.title || p.optimized_post?.title || `Post ${i + 1}`}
              </p>
            </div>
          ))}
        </div>
      )}

      {r?.social_posts?.length > 0 && (
        <div>
          <h3 className="text-sm font-semibold text-gray-900 mb-2">
            Social Posts ({r.social_posts.length})
          </h3>
          {r.social_posts.map((p: any, i: number) => (
            <div key={i} className="p-3 bg-gray-50 rounded-lg mb-2">
              <span className="text-xs font-medium text-indigo-600">{p.platform}</span>
              <p className="text-sm text-gray-700 mt-1 line-clamp-2">{p.text}</p>
            </div>
          ))}
        </div>
      )}

      {r?.email_sequences?.length > 0 && (
        <div>
          <h3 className="text-sm font-semibold text-gray-900 mb-2">
            Email Sequences ({r.email_sequences.length})
          </h3>
          {r.email_sequences.map((seq: any, i: number) => (
            <div key={i} className="p-3 bg-gray-50 rounded-lg mb-2">
              <p className="text-sm font-medium">{seq.sequence_name || `Sequence ${i + 1}`}</p>
              <p className="text-xs text-gray-500">{seq.emails?.length || 0} emails</p>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default function CampaignPage() {
  return (
    <ToolPage
      title="Full Campaign"
      icon={Megaphone}
      description="Generate a complete multi-channel marketing campaign"
      endpoint="/campaign"
      fields={fields}
      renderResult={renderResult}
    />
  )
}
